export default {
    get: { global: [], personal: [] },
};
